export enum Duration {
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  ETERNITY = 'ETERNITY',
}

export default Duration;
